<template>
  <div class="rank-com">
    <TxBg src="oldclassic_m_rank_beijing-liebiao" class="center">
      <!-- <div class="empty"></div> -->
      <TxBg src="oldclassic_m_rank_title" class="mt-110" />
      <search class="rank-search -mt-40" />
      <div class="fanhui-com">
        <TxBtn src="rank_fanhui" name="返回" @click="goBack(router)" />
      </div>

      <query @do_query="do_query" :default_values="default_values" />

      <TxBg
        src="oldclassic_m_rank_liebiaodiban"
        class="-mt-24 pt-130 overflow-x px-44"
      >
        <div class="table-type">{{ rank_type_name }}排行榜</div>
        <div class="table-tips">< 左右滑动查看多信息！ ></div>
        <div class="overflow-x">
          <tx-table
            :columns="columns"
            :data="ranks"
            class="rank-table"
          ></tx-table>
        </div>
      </TxBg>

      <TxPagination
        @pageChange="pageChange"
        v-model:page="page"
        :total="total"
        :size="size"
      />
    </TxBg>

    <Link />
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
const { is_mobile, schools, sectors, rank_type } = inject('GlobalStore');
import { get_rank } from '@utils/api';
import query from './components/rank/query.vue';
import search from './components/search.vue';
import Link from './components/link.vue';
import { goBack } from '@utils/goBack';
import eventEmitter from '@utils/event';

const router = useRouter();
const route = useRoute();
const ranks = ref([]);

const total = ref(0);
const size = ref(20);
const page = ref(1);

const default_values = computed(() => route.query);

const columns = ref([
  {
    title: '排名',
    key: 'rank',
  },
  {
    title: '角色',
    key: 'role',
    render: ({ row }) => {
      return h(
        'a',
        {
          class: 'pointer',
          onClick: () => roleClick(row),
        },
        row.role
      );
    },
  },
  // {
  //   title: '大区',
  //   key: 'server',
  //   render: ({ row }) => {
  //     const name = sector_name(row.server);
  //     return h('span', {}, name);
  //   },
  // },
  {
    title: '服务器',
    key: 'server',
    render: ({ row }) => {
      const name = server_name(row.server);
      return h('span', {}, name);
    },
  },
  {
    title: '等级',
    key: 'level',
  },
  {
    title: '门派',
    key: 'school',
    render: ({ row }) => {
      const _shcool_name = shcool_name(row.school);
      return h('span', {}, _shcool_name);
    },
  },
  {
    title: '势力',
    key: 'clan',
    render: ({ row }) => {
      return h(
        'a',
        {
          class: 'pointer',
          onClick: () => clanClick(row),
        },
        row.clan
      );
    },
  },
  {
    title: '人物修为',
    key: 'xiuwei',
  },
  {
    title: '装备评价',
    key: 'equ_xiuwei',
  },
  {
    title: '总修为',
    key: 'total_xiuwei',
  },
  // {
  //   title: '风华值',
  //   key: 'fenghua',
  // },
]);

const params = computed(() => route.query);

const load_rank = (_params = {}) => {
  get_rank({ page: page.value, ...params.value, ..._params }).then((res) => {
    console.log('get_rank测试', res);
    if (res.code == 0) {
      ranks.value = [...res.data.ranks];
      total.value = res.data.page_info.total;
      size.value = res.data.page_info.size;
      page.value = res.data.page_info.page;
    } else {
      eventEmitter.emit('toast', {
        text: res.errorMsg,
        duration: 5,
      });
    }
  });
};

onMounted(() => {
  console.log('params', params.value);
  load_rank(params.value);
});

const shcool_name = (shcool_id) => {
  return schools.value[shcool_id];
};

const sector_name = (server) => {
  return sectors.value[server] || '';
};

const server_name = (server) => {
  return sectors.value[server]?.name || server;
};

const roleClick = (record) => {
  const routeData = {
    path: `/role`,
    query: {
      key: record.key,
    },
  };
  router.push(routeData);
  // 解析路由获取完整 URL
  // const resolved = router.resolve(routeData);
  // const fullUrl = window.location.origin + resolved.href;

  // 在新标签页打开
  // window.open(fullUrl, '_blank');
  // window.open(fullUrl);  // 移动端再当前也打开
};

const clanClick = (record) => {
  console.log('clanClick', record);
};

const pageChange = (page) => {
  load_rank({ page });
};

const do_query = (filter_op) => {
  const newQuery = { ...route.query, ...filter_op };
  router.replace({
    path: `/rank`,
    query: newQuery,
  });
  load_rank(filter_op);
};

const rank_type_name = computed(() => {
  let _type = params.value.order_key;
  if (!_type || _type == '') {
    _type = 'total_xiuwei';
  }
  // return rank_type.value[_type] || '';
  const result = rank_type.value.find((item) => item.value == _type);

  return result?.text;
});
</script>
